import React from 'react';

const Hero: React.FC = () => {
  return (
    <section id="inicio" className="hero">
      <div className="hero-container">
        <h2>Especialistas en Equipos Médicos</h2>
        <p>
          Brindamos mantenimiento profesional de equipo hospitalario y 
          comercializamos insumos médicos de la más alta calidad
        </p>
        <a href="#contacto" className="cta-button">
          Contáctanos Ahora
        </a>
      </div>
    </section>
  );
};

export default Hero;
